/** Page key the app shell uses for every `/courses/*` route (see `_getCurrentPage` in root.tsx). */
export const COURSES_PAGE_NAME = 'Courses';

/** Class on the module's root element that scopes the courses design tokens (styles/courses.css). */
export const COURSES_THEME_CLASS = 'courses-theme';

/**
 * Bottom space below `lg`, where the app's floating bottom nav shows (68px tall,
 * `max(32px, safe-area)` from the bottom; the shell's `<main>` already reserves 40px), so the
 * end of a page can scroll clear of it. Signed-in pages also clear the notes button above it.
 */
export const COURSES_NAV_CLEARANCE_CLASS =
	'max-lg:pb-[calc(max(32px,env(safe-area-inset-bottom))+116px)]';
export const COURSES_PUBLIC_NAV_CLEARANCE_CLASS =
	'max-lg:pb-[calc(max(32px,env(safe-area-inset-bottom))+44px)]';

/** Wait after the auth modal closes before treating a still-signed-out guest as having left. */
export const GUEST_AUTH_DISMISS_GRACE_MS = 500;
